export { default as Landing } from './Landing'
export { default as Nav } from './Nav'
export { default as About } from './About'
export { default as Experience } from './Experience'
export { default as Interests } from './Interests'
export { default as Services } from './Services'
export { default as Coverage } from './Coverage'
export { default as Contact } from './Contact'
export { default as Publications } from './Publications'
export { default as Footer } from './Footer'